import { type Control, FieldPath, FieldValues, type UseFormSetValue } from 'react-hook-form';
import { RadioGroupField } from '@brighte/form-components';
import { Columns } from '@spark-web/columns';
import { RadioCard } from '@spark-web/radio';
import { Text } from '@spark-web/text';
import { LABELS, OWNERSHIP_DETAILS } from '@utils';

type OwnershipTypeProps<TFieldValues extends FieldValues = FieldValues> = {
  name: FieldPath<TFieldValues>;
  control: Control<TFieldValues>;
  setValue: UseFormSetValue<TFieldValues>;
  options?: { label: string; value: string }[];
  description?: string;
};

function OwnershipType<TFieldValues extends FieldValues = FieldValues>({
  name,
  control,
  setValue,
  options = OWNERSHIP_DETAILS.OWNERSHIP_TYPE_OPTIONS,
  description = OWNERSHIP_DETAILS.OWNERSHIP_TYPE_DESCRIPTION,
}: Readonly<OwnershipTypeProps<TFieldValues>>) {
  const { OWNERSHIP_TYPE } = LABELS;

  const handleTypeChange = (selectedValue: string) => {
    setValue(name, selectedValue as Parameters<typeof setValue>[1]);
  };

  return (
    <RadioGroupField name={name} control={control} label={OWNERSHIP_TYPE} onChange={handleTypeChange}>
      <Text tone="muted" size="small">
        {description}
      </Text>
      <Columns gap="large">
        {options.map(({ label, value }) => (
          <RadioCard key={value} value={value}>
            <Text>{label}</Text>
          </RadioCard>
        ))}
      </Columns>
    </RadioGroupField>
  );
}

export default OwnershipType;
